// wp-icons — Calendar & Time (7)
import { createWpIcon } from './createIcon.js';

export const Calendar = createWpIcon('Calendar', [
  ['path', { d: 'M8 2v4', key: 'a' }],
  ['path', { d: 'M16 2v4', key: 'b' }],
  ['rect', { width: 18, height: 18, x: 3, y: 4, rx: 2, key: 'c' }],
  ['path', { d: 'M3 10h18', key: 'd' }],
]);
export const CalendarDays = createWpIcon('CalendarDays', [
  ['path', { d: 'M8 2v4', key: 'a' }],
  ['path', { d: 'M16 2v4', key: 'b' }],
  ['rect', { width: 18, height: 18, x: 3, y: 4, rx: 2, key: 'c' }],
  ['path', { d: 'M3 10h18', key: 'd' }],
  ['path', { d: 'M8 14h.01', key: 'e' }],
  ['path', { d: 'M12 14h.01', key: 'f' }],
  ['path', { d: 'M16 14h.01', key: 'g' }],
  ['path', { d: 'M8 18h.01', key: 'h' }],
  ['path', { d: 'M12 18h.01', key: 'i' }],
  ['path', { d: 'M16 18h.01', key: 'j' }],
]);
export const CalendarClock = createWpIcon('CalendarClock', [
  ['path', { d: 'M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5', key: 'a' }],
  ['path', { d: 'M16 2v4', key: 'b' }],
  ['path', { d: 'M8 2v4', key: 'c' }],
  ['path', { d: 'M3 10h5', key: 'd' }],
  ['path', { d: 'M17.5 17.5 16 16.3V14', key: 'e' }],
  ['circle', { cx: 16, cy: 16, r: 6, key: 'f' }],
]);
export const CalendarX = createWpIcon('CalendarX', [
  ['path', { d: 'M8 2v4', key: 'a' }],
  ['path', { d: 'M16 2v4', key: 'b' }],
  ['rect', { width: 18, height: 18, x: 3, y: 4, rx: 2, key: 'c' }],
  ['path', { d: 'M3 10h18', key: 'd' }],
  ['path', { d: 'm14 14-4 4', key: 'e' }],
  ['path', { d: 'm10 14 4 4', key: 'f' }],
]);
export const Clock = createWpIcon('Clock', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['polyline', { points: '12 6 12 12 16 14', key: 'b' }],
]);
export const Timer = createWpIcon('Timer', [
  ['line', { x1: 10, x2: 14, y1: 2, y2: 2, key: 'a' }],
  ['line', { x1: 12, x2: 15, y1: 14, y2: 11, key: 'b' }],
  ['circle', { cx: 12, cy: 14, r: 8, key: 'c' }],
]);
export const History = createWpIcon('History', [
  ['path', { d: 'M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8', key: 'a' }],
  ['path', { d: 'M3 3v5h5', key: 'b' }],
  ['path', { d: 'M12 7v5l4 2', key: 'c' }],
]);
export const Cake = createWpIcon('Cake', [
  ['path', { d: 'M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8', key: 'a' }],
  ['path', { d: 'M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1', key: 'b' }],
  ['path', { d: 'M2 21h20', key: 'c' }],
  ['path', { d: 'M7 8v3', key: 'd' }],
  ['path', { d: 'M12 8v3', key: 'e' }],
  ['path', { d: 'M17 8v3', key: 'f' }],
  ['path', { d: 'M7 4h.01', key: 'g' }],
  ['path', { d: 'M12 4h.01', key: 'h' }],
  ['path', { d: 'M17 4h.01', key: 'i' }],
]);
